// extracted by mini-css-extract-plugin
export default {"Text":"AuthorDisplayName-module__Text__wpf1GkQ","truncate":"AuthorDisplayName-module__truncate__B2zTJZ_"};